import { useCallback, useEffect, useState } from 'react';
import type { Api } from '../api.js';

/** Loads one org-scoped resource; reload() after a change. */
export function useOrgData<T>(api: Api, orgId: string, path: string) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState('');
  const reload = useCallback(async () => {
    try {
      setError('');
      setData(await api.get<T>(orgId, path));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not load this page.');
    }
  }, [api, orgId, path]);
  useEffect(() => {
    void reload();
  }, [reload]);
  return { data, error, reload };
}
